module.exports = __webpack_public_path__ + "img/152.2a6e7747.jpg";